export const DEFAULT_SELECT_VALUE = 'default';
export const OTHER_TYPE = 'Other';
export const INPUT_MAX_HEIGHT = 40;
